import React from 'react';
import PropTypes from 'prop-types';

import {
  NOT_GRADED,
  NOT_SUBMITTED,
  LATE_SUBMISSION,
  AWAITING_DECISION,
} from './tags';
import { providers } from '$variables/constants';
import Pill from '$components/Pill';
import { Container } from './InfoTags.styled';

const getInfoTags = ({
  isAwaitingDecision,
  hasSubmission,
  lateSubmission,
  grade,
  provider,
}) => {
  // highest priority to awaiting decision
  if (isAwaitingDecision) {
    return [AWAITING_DECISION];
  }

  // if grade is not present and its a manual assignment
  // it is marked as not graded
  // because there is no concept of submission in manual assignments
  if (!grade && provider === providers.MANUAL) {
    return [NOT_GRADED];
  }

  // if no grade and submission is present with late submission
  if (!grade && hasSubmission && lateSubmission) {
    return [NOT_GRADED, LATE_SUBMISSION];
  }

  // if no grade but subsmission is present
  if (!grade && hasSubmission) {
    return [NOT_GRADED];
  }

  // no grade and no submission
  if (!hasSubmission) {
    return [NOT_SUBMITTED];
  }

  // graded and late submission
  if (lateSubmission) {
    return [LATE_SUBMISSION];
  }

  return [];
};

const InfoTags = ({
  hasSubmission,
  lateSubmission,
  isAwaitingDecision,
  grade,
  provider,
}) => {
  const tags = getInfoTags({
    hasSubmission,
    lateSubmission,
    grade,
    isAwaitingDecision,
    provider,
  });

  if (!tags.length) {
    return null;
  }

  return (
    <Container>
      {tags.map((tag) => (
        <Pill key={tag.key} size="compact" look={tag.color}>
          {tag.title}
        </Pill>
      ))}
    </Container>
  );
};

InfoTags.propTypes = {
  grade: PropTypes.string,
  hasSubmission: PropTypes.bool.isRequired,
  lateSubmission: PropTypes.bool.isRequired,
  isAwaitingDecision: PropTypes.bool,
  provider: PropTypes.string.isRequired,
};

InfoTags.defaultProps = {
  grade: '',
  isAwaitingDecision: false,
};

export default InfoTags;
